import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class WMSCodOperService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/wms-codoper/${this.idconta}`)

    const dataFormatted = response.data.map((codigo) => ({
      ...codigo,
      codoper: String(codigo.codoper).trim(),
    }))

    return dataFormatted
  }

  async getById(id) {
    const response = await apinode.get(`/wms-codoper/${id}/${this.idconta}`)

    return response.data
  }

  async search({ search }) {
    const url = unifyParams(`/wms-codoper/search/${this.idconta}`, [
      {
        key: 'descricao',
        value: search,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async create(data) {
    await apinode.post(`/wms-codoper/${this.idconta}`, data)
  }

  async update(id, data) {
    await apinode.put(`/wms-codoper/${id}/${this.idconta}`, data)
  }

  async delete(id) {
    await apinode.delete(`/wms-codoper/${id}/${this.idconta}`)
  }
}

export default new WMSCodOperService()
